import visitParents from 'unist-util-visit-parents';
import exec from 'regexp-match-indices';
var splitTextIntoNodes = function (text, decorator) {
    decorator.match.lastIndex = 0;
    var nodes = [];
    var lastIndex = 0;
    while (true) {
        var result = exec(decorator.match, text);
        if (!result) {
            break;
        }
        var captureGroupIndex = decorator.captureGroupIndex || 0;
        var _a = result.indices[captureGroupIndex], captureGroupStartIndex = _a[0], captureGroupEndIndex = _a[1];
        var matchedString = text.slice(captureGroupStartIndex, captureGroupEndIndex);
        nodes.push({
            type: 'text',
            value: text.substring(lastIndex, captureGroupStartIndex),
        }, {
            type: 'element',
            tagName: decorator.component,
            properties: decorator.properties,
            children: [
                {
                    type: 'text',
                    value: matchedString,
                },
            ],
        });
        lastIndex = captureGroupEndIndex;
        if (!decorator.match.global) {
            break;
        }
    }
    if (text.length > lastIndex) {
        nodes.push({
            type: 'text',
            value: text.substring(lastIndex),
        });
    }
    decorator.match.lastIndex = 0;
    return nodes;
};
var isCodeBlock = function (node) {
    return node.tagName === 'code';
};
export var decoratorPlugin = function (options) {
    var _a;
    if (!((_a = options.decorators) === null || _a === void 0 ? void 0 : _a.length)) {
        return;
    }
    var visitor = function (node, parents) {
        var decorator = options.decorators.find(function (entry) {
            return node.type === 'text' && entry.match.test(node.value);
        });
        if (!decorator) {
            return;
        }
        if (decorator.ignoreCodeBlock !== false && parents.some(isCodeBlock)) {
            return visitParents.SKIP;
        }
        node.type = 'element';
        node.tagName = 'span';
        node.children = splitTextIntoNodes(node.value, decorator);
        return visitParents.SKIP;
    };
    return function (tree) {
        visitParents(tree, visitor, true);
    };
};
